import React from "react";
import { Navigate } from "react-router-dom";
import { useUserStore } from "../utils/userStore";
import { RouterConstant } from "./index";

interface Props {
  children: React.ReactNode;
}

const TeacherProtectedRoute: React.FC<Props> = ({ children }) => {
  const { ROUTERS_PATH } = RouterConstant;
  const isAuthenticated = useUserStore((state) => state.isAuthenticated);
  const isTeacher = useUserStore((state) => state.isTeacher);
  const isAdmin = useUserStore((state) => state.isAdmin);

  if (!isAuthenticated() || (!isTeacher() && !isAdmin())) {
    return <Navigate to={ROUTERS_PATH.USERREGISTRATIONINITIAL} replace />;
  }

  return <>{children}</>;
};

export default TeacherProtectedRoute;
